import React from 'react';
import PropTypes from 'prop-types';

import AdvWorkflow from '../AdvWorkflow/AdvWorkflowContainer';
import TaxesLocation from './Steps/TaxesLocationContainer';
import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';

const TaxesWorkflowView = ({ branch, workflowId }) => (
  <AdvWorkflow branch={branch} workflowId={workflowId} steps={[TaxesLocation]} />
);

TaxesWorkflowView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
};

export default TaxesWorkflowView;
